/**
 * Client for the general (PMS) repricing Schedule rules, and the strategy
 * feed the Calendar cross-references.
 *
 * Before CU-869f043cf this module was a localStorage mock
 * (`ds_schedule_rules_v1`) that seeded four invented rules on first
 * visit — configuration that belonged to one browser, could not be
 * audited and the engine could not read.
 */
import { BACKEND_APIS } from '@constants/routes'
import { makeClient, resource } from 'Pages/DsRepricing/@services/http'
import { strategiesApi } from 'Pages/DsRepricing/Page/@services/api'

export { ApiError } from 'Pages/DsRepricing/@services/http'

export const API = BACKEND_APIS.GENERAL_REPRICING_SCHEDULE_API

const http = makeClient(API)
const rules = resource(http, '/rules')

export const scheduleApi = {
	rules: {
		...rules,
		setActive: (id, isActive, reason) =>
			http.put(`/rules/${id}/active`, { is_active: isActive, reason }),
		/** Launch one rule now, whether or not it is due. Audited server-side
		 *  as `force_run`; the engine answers with what it created. */
		runNow: (id, reason) => http.post(`/rules/${id}/run-now`, { reason }),
	},
	/** What each pass of the sweep did. `progress_ok: false` means the
	 *  search counts were too slow to wait for and every `searches` is
	 *  null — see the webback `executions` service. */
	executions: (limit = 30) => http.get(`/executions?limit=${limit}`),
	/** What ran on each day of a range, folded: passes, searches created,
	 *  decisions by type, push state. The Calendar's summary of past days.
	 *  Days are UTC (`tz` in the answer says so). */
	executionsByDay: (fromIso, toIso) =>
		http.get(`/executions/by-day?from=${encodeURIComponent(fromIso)}&to=${encodeURIComponent(toIso)}`),
	/** "Push now": send the ladders of every search of this pass that is
	 *  still waiting. Audited server-side as `force_flush`; 409 when
	 *  nothing is pending or the engine refused every search. */
	flushExecution: (executionId, reason) =>
		http.post(`/executions/${encodeURIComponent(executionId)}/flush`, { reason: reason || null }),
	/**
	 * "Con tu config actual, esto es lo que se va a lanzar." Same code path
	 * in the engine as the real run, so it cannot drift. Writes nothing.
	 * Without `ruleId` it answers for whatever is due right now.
	 */
	preview: (ruleId) => http.get(`/preview${ruleId ? `?rule_id=${encodeURIComponent(ruleId)}` : ''}`),
	/** The Calendar reads real strategies; see `useStrategyFeed`. */
	strategies: strategiesApi,
}
